const VERSION_DATA_CENTER = "base-platform/v2"

// 获取OSSToken
// export const ossToken = {
//   url: `/${VERSION_DATA_CENTER}/base/oss/token`,
// }
export const ossToken = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/oss/token`,
}

// OSS上传前，保存记录
// export const fileSave = {
//   url: `/${VERSION_DATA_CENTER}/base/file/save`,
//   method: "POST",
// }
export const fileSave = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/file/save`,
  method: "POST",
}

// OSS上传后，获取文件地址
export const fileInfo = {
  url: `/${VERSION_DATA_CENTER}/base/file/info`,
}

// 校验人脸，成功返回文件id
export const faceCheck = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/file/face/check`,
  method: "POST",
}

// export const faceCheck = {
//   url: `/${VERSION_DATA_CENTER}/physical/health/import`,
//   method: "POST",
// }

// 分页获取学生信息（class：班级）调这个
// export const studentList = {
//   url: `/${VERSION_DATA_CENTER}/base/student/page`,
// }


// 获取教师列表（class：班级）调这个
export const teacherList = {
  url: `/${VERSION_DATA_CENTER}/base/teacher/list`,
}

// 部门添加人员时获取的部门树与教师列表
export const allTeacherAndTree = {
  url: `/${VERSION_DATA_CENTER}/base/department/allTeacherAndTree`,
}

// 部门添加人员时获取的部门树与教师列表
export const allTeacherAndTreePost = {
  url: `/${VERSION_DATA_CENTER}/base/department/allTeacherAndTree`,
  method: "POST",
}

// 部门添加人员时获取的部门树与教师列表
export const treeAndAllUser = {
  url: `/${VERSION_DATA_CENTER}/base/grade/treeAndAllUser`,
}

